import { useGetQueryCode } from "@/shared/hooks/use-get-query-code.hook";

import { ASSESSMENT_CODE_SEARCH } from "@/routing/AppRouter/routes.constants";

export function useGetAssessmentQueryCode(): string | null {
  return useGetQueryCode(ASSESSMENT_CODE_SEARCH);
}
